<script setup>

</script>
<template>
<i class="comm-icon">
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M16.5 16.5L12.8808 12.8808M12.8808 12.8808C13.4999 12.2617 13.991 11.5268 14.326 10.7179C14.661 9.90909 14.8335 9.04216 14.8335 8.16666C14.8335 7.29115 14.6611 6.42422 14.326 5.61537C13.991 4.80651 13.4999 4.07156 12.8808 3.45249C12.2617 2.83342 11.5268 2.34234 10.7179 2.0073C9.90909 1.67226 9.04216 1.49982 8.16666 1.49982C7.29115 1.49982 6.42422 1.67226 5.61537 2.0073C4.80651 2.34234 4.07156 2.83342 3.45249 3.45249C2.20221 4.70276 1.49982 6.3985 1.49982 8.16666C1.49982 9.93481 2.20221 11.6305 3.45249 12.8808C4.70276 14.1311 6.3985 14.8335 8.16666 14.8335C9.93481 14.8335 11.6305 14.1311 12.8808 12.8808Z" stroke="#174FDC" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</i>
</template>
<style scoped>

</style>